import { CircleCheckBig, StickyNote } from "lucide-react";

import { cn } from "../../lib/utils";
import { motivoDeEncerramento } from "../../helpers/motivosDeEncerramento";
import useMotivosDeEncerramento from "../../hooks/useMotivosDeEncerramento";

// Por que este atendimento acabou.
//
// O motivo e a observação eram gravados a cada encerramento e não apareciam em
// tela nenhuma — dado morto no banco. Este selo é o mesmo em toda parte (linha
// da lista, cabeçalho da conversa), para o motivo ser reconhecido pela cor
// antes de ser lido.
const SeloDeEncerramento = ({ ticket, mostrarObservacao = false, className }) => {
	// O hook não é usado pelo valor: é ele que faz o selo redesenhar quando a
	// lista de motivos da empresa chega da API. Sem isso o selo ficaria com a
	// chave crua ("sem_retorno") até o próximo render por outro motivo.
	useMotivosDeEncerramento();

	if (ticket?.status !== "closed") return null;

	const motivo = motivoDeEncerramento(ticket.closeReason);
	const nota = ticket.closeNote?.trim();

	if (!motivo && !nota) return null;

	return (
		<span className={cn("inline-flex flex-wrap items-center gap-1", className)}>
			{motivo && (
				<span
					title={nota ? `${motivo.rotulo} — ${nota}` : motivo.rotulo}
					className={cn(
						"inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide",
						motivo.classe,
					)}
				>
					<CircleCheckBig className="h-2.5 w-2.5" />
					{motivo.rotulo}
				</span>
			)}

			{/* Na linha da lista a observação vira só o title do selo: espaço ali é
			    o recurso mais escasso da tela. No cabeçalho ela aparece por
			    inteiro, que é onde se lê com calma. */}
			{nota && mostrarObservacao && (
				<span
					className="inline-flex max-w-full items-center gap-1 rounded bg-muted px-1.5 py-0.5 text-[11px] text-muted-foreground"
					title={nota}
				>
					<StickyNote className="h-2.5 w-2.5 shrink-0" />
					<span className="truncate">{nota}</span>
				</span>
			)}
		</span>
	);
};

export default SeloDeEncerramento;
